import { Card } from '../../components';

export type DeviceCodeConfirmPageProps = {
  xsrf: string;
  action: string;
  userCode: string;
  clientId: string;
  deviceInfo?: Record<string, string>;
};

export function DeviceCodeConfirmPage({
  xsrf,
  action,
  userCode,
  clientId,
  deviceInfo,
}: DeviceCodeConfirmPageProps): JSX.Element {
  return (
    <Card header={<h2 className="text-2xl font-medium leading-6 text-gray-900">Authorize Device</h2>}>
      <div className="flex flex-col gap-4 p-2">
        <p className="text-sm text-gray-600">The following device is requesting access to your account.</p>
        <div className="rounded-md bg-gray-50 border border-gray-200 p-3 text-sm text-gray-700 space-y-1">
          <div>
            <span className="font-medium">Client: </span>
            {clientId}
          </div>
          {deviceInfo?.ip && (
            <div>
              <span className="font-medium">IP: </span>
              {deviceInfo.ip}
            </div>
          )}
        </div>
        <form id="device-authorize-form" method="post" action={action}>
          <input type="hidden" name="xsrf" value={xsrf} />
          <input type="hidden" name="user_code" value={userCode} />
          <input type="hidden" name="confirm" value="yes" />
        </form>
        <form id="device-deny-form" method="post" action={action}>
          <input type="hidden" name="xsrf" value={xsrf} />
          <input type="hidden" name="user_code" value={userCode} />
        </form>
        <div className="mt-4 flex flex-row justify-between gap-4">
          <button
            type="submit"
            form="device-deny-form"
            className="inline-flex w-full justify-center rounded-md border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-5minds-blue-900 focus:ring-offset-2"
          >
            Deny
          </button>
          <button
            type="submit"
            form="device-authorize-form"
            autoFocus
            className="inline-flex w-full justify-center rounded-md border border-transparent bg-5minds-blue-800 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-5minds-blue-900 focus:outline-none focus:ring-2 focus:ring-5minds-blue-900 focus:ring-offset-2"
          >
            Authorize
          </button>
        </div>
      </div>
    </Card>
  );
}
